import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { SessionService } from '@app/shared/helpers';
import { takeUntil } from 'rxjs/operators';
import { TokenService } from '@app/shared/services/token.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
})
export class CallbackComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  loader: boolean = false;
  constructor(
    private router: Router,
    private auth0Service: Auth0Service,
    private sessionService: SessionService,
    private tokenService: TokenService
  ) {}

  async ngOnInit() {
    this.auth0Service.isAuthenticated$.subscribe(async (data) => {
      if (data) {
        await this.getAppToken();
        this.router.navigate(['/account/apps']);
      } else {
        this.auth0Service.loginWithRedirect();
      }
    });
  }
  /**
   * Get application token
   */
  getAppToken() {
    return new Promise((resolve) => {
      this.auth0Service
        .getAccessTokenSilently()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          if (data) {
            this.sessionService.setApplicationToken(data);
            this.tokenService.startRefreshTokenTimer();
            let decodedToken: any = this.tokenService.getDecodedToken();
            if (decodedToken?.email) {
              this.sessionService.setEmail(decodedToken.email);
            }
            if (decodedToken?.sub) {
              this.sessionService.setUserId(decodedToken.sub);
            }
            resolve(data);
          }
        });
    });
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
